export default __webpack_public_path__ + "static/media/Shampoo_SLEEK_LIGHT_250_O.89ee42bd.png";